/** Landing hero copy — edit here, not in the JSX components. */

export const headline = {
  primary: "React.",
  secondary: "Highly Optimized.",
} as const;

export const subtitle = {
  lead: "Compiled to signals and fine-grained updates.",
  lines: [
    "No virtual DOM.",
    "No refactoring.",
    "No React runtime.",
    "No wasted renders.",
    "Your app, all your libraries.",
  ],
} as const;

export const cta = "Learn more";
